<div class="form-group">
    <label class="input-label">Min value</label>
    <input class="form-control"
           name="required"
           type="number"
           value="{{fieldOptions.validate.min}}"
           [(ngModel)]="fieldOptions.validate.min">
</div>